var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.5,
    width: 3,
    height: 3,
    rx: 0.9,
    fill: "#F1FAEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2.1,
    width: 12.5,
    height: 1.8,
    rx: 0.9,
    fill: "#F1FAEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 6.5,
    width: 3,
    height: 3,
    rx: 0.9,
    fill: "#F1FAEE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 7.1,
    width: 12.5,
    height: 1.8,
    rx: 0.9,
    fill: "#F1FAEE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 11.5,
    width: 3,
    height: 3,
    rx: 0.9,
    fill: "#F1FAEE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12.1,
    width: 12.5,
    height: 1.8,
    rx: 0.9,
    fill: "#F1FAEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseList);
export default __webpack_public_path__ + "static/media/courseList.27657924bbff9037d0f6718c996026b6.svg";
export { ForwardRef as ReactComponent };